import React from "react";
import {
  PLATFORM_TERMS_ARTICLES,
  TERMS_VERSION,
  TERMS_EFFECTIVE_DATE,
  TERMS_INTRO,
  TERMS_SIGNOFF,
} from "constants/legal.constants";
import SbCard from "uiCore/SbCard/SbCard";
import {
  TermsContentStyled,
  TermsHeaderStyled,
  TermsHeaderTitleStyled,
  TermsHeaderMetaStyled,
  IntroLeadStyled,
  NoticeBoxStyled,
  ArticleHeadingStyled,
  SignoffStyled,
  ExclusionBoxStyled,
} from "Pages/Legal/Legal.styles";

// Bold the "Label:" prefix of a bullet, if present.
const renderBullet = (item, i) => {
  const idx = item.indexOf(": ");
  if (idx === -1) return <li key={i}>{item}</li>;
  return (
    <li key={i}>
      <strong>{item.slice(0, idx + 1)}</strong>
      {item.slice(idx + 1)}
    </li>
  );
};

const renderBlock = (block, i) => {
  if (block.type === "ul") {
    return <ul key={i}>{block.items.map(renderBullet)}</ul>;
  }
  if (block.type === "table") {
    return (
      <table key={i}>
        <thead>
          <tr>{block.head.map((h, j) => <th key={j}>{h}</th>)}</tr>
        </thead>
        <tbody>
          {block.rows.map((row, r) => (
            <tr key={r}>
              {row.map((cell, c) => (
                <td key={c}>{c === 0 ? <strong>{cell}</strong> : cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
  if (block.type === "notice") {
    return (
      <NoticeBoxStyled key={i}>
        <strong>{block.label}</strong> {block.text}
      </NoticeBoxStyled>
    );
  }
  if (block.type === "callout") {
    return (
      <ExclusionBoxStyled key={i}>
        <strong>{block.label}</strong> {block.text}
      </ExclusionBoxStyled>
    );
  }
  return <p key={i}>{block.text}</p>;
};

// Read-only render of the End-User Platform Terms.
const TermsBanner = (
  <TermsHeaderStyled>
    <TermsHeaderTitleStyled>
      End-User Platform Terms & Data Protection Notice
    </TermsHeaderTitleStyled>
    <TermsHeaderMetaStyled gap={24} wrap>
      <span><strong>Document ID:</strong> {TERMS_VERSION}</span>
      <span><strong>Effective Date:</strong> {TERMS_EFFECTIVE_DATE}</span>
    </TermsHeaderMetaStyled>
  </TermsHeaderStyled>
);

const PlatformTerms = () => (
  <SbCard cover={TermsBanner}>
    <TermsContentStyled>
      <IntroLeadStyled>{TERMS_INTRO.lead}</IntroLeadStyled>
      <p>{TERMS_INTRO.welcome}</p>
      <NoticeBoxStyled>
        <strong>{TERMS_INTRO.noticeLabel}</strong> {TERMS_INTRO.notice}
      </NoticeBoxStyled>

      {PLATFORM_TERMS_ARTICLES.map((article) => (
        <div key={article.heading}>
          <ArticleHeadingStyled>{article.heading}</ArticleHeadingStyled>
          {article.blocks.map(renderBlock)}
        </div>
      ))}

      <SignoffStyled>{TERMS_SIGNOFF}</SignoffStyled>
    </TermsContentStyled>
  </SbCard>
);

export default PlatformTerms;
